import { Drawer } from "@mui/material";
import React from "react";

import { useStyles } from "./styles";
import TakeawayOrdersList from "./TakeawayOrdersList";

const TakeawayOrders = ({ open, onClose }) => {
    const classes = useStyles();

    const handleClose = () => {
        onClose?.();
    };

    return (
        <React.Fragment>
            <Drawer
                className={classes.Drawer}
                anchor="right"
                open={open}
                onClose={handleClose}
            >
                <div className={classes.DrawerWrapper}>
                    <TakeawayOrdersList onClose={onClose} />
                </div>
            </Drawer>
        </React.Fragment>
    );
};

export default TakeawayOrders;
